@if (license) {
  <ip-header [label]="'catalog.image_preview.license' | transloco"></ip-header>
  <div [innerHTML]="license" class="p-2 text-gray border-top license-text-container"></div>
}
